<img src="/assets/images/voyado-icon.svg" style="width: 120px" />
@if (isLoaded) {
    @if (isFound) {
        <div>
            <h4 class="title" translate>Contact Information</h4>
            <table class="voyado-table">
                <tr>
                    <td class="property-name" translate>First name:</td>
                    <td class="w-100">{{ data.personalInfo.firstName }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>Last name:</td>
                    <td class="w-100">{{ data.personalInfo.lastName }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>Gender:</td>
                    <td class="w-100">{{ data.personalInfo.gender }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>Address:</td>
                    <td class="w-100">{{ data.personalInfo.address }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>Zipcode:</td>
                    <td class="w-100">{{ data.personalInfo.zipCode }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>City:</td>
                    <td class="w-100">{{ data.personalInfo.city }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>Email:</td>
                    <td class="w-100">{{ data.personalInfo.email }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>Mobile:</td>
                    <td class="w-100">{{ data.personalInfo.mobilePhone }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>Tracking:</td>
                    <td class="w-100">{{ data.personalInfo.isTracking ? ('Yes' | translate) : ('No' | translate) }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>Registered store:</td>
                    <td class="w-100">{{ data.personalInfo.registeredStore.name }}</td>
                </tr>
                <tr>
                    <td class="property-name" translate>Favorite store:</td>
                    <td class="w-100">{{ data.personalInfo.favouriteStore.name }}</td>
                </tr>
            </table>

            <h4 class="title" translate>Transactions</h4>
            <table class="voyado-table">
                @for (item of data.transactions.items; track item) {
                    <tr>
                        <td class="date">{{ item.createdDate | date: 'dd/MM/yyyy HH:mm' }}</td>
                        <td class="store-name">{{ item.storeName }}</td>
                        <td class="net-price-sum">{{ item.localNetPriceSum | number: '.2' }}</td>
                        <td>({{ item.localCurrency }}),</td>
                        <td class="number-of-items">
                            &nbsp;{{ item.numberOfItems }}
                            {{ 'line items' | translate }}
                        </td>
                    </tr>
                }
            </table>
            <a class="mt-3" (click)="openVoyadoTransactionsModal()" translate>View all transactions</a>

            <h4 class="title" translate>Messages</h4>
            <table class="voyado-table">
                @for (item of data.messages.items; track item) {
                    <tr>
                        <td class="date">{{ item.sendDateTime | date: 'dd/MM/yyyy HH:mm' }}</td>
                        <td class="name">{{ item.name }}</td>
                        <td class="status">{{ item.status }}</td>
                    </tr>
                }
            </table>
            <a class="mt-3" (click)="openVoyadoMessagesModal()" translate>View all messages</a>
        </div>
    } @else {
        <div>
            <p style="margin-top: 20px">
                {{ "Sorry, but we couldn't find any related to" | translate }}
                "{{ email }}"
            </p>
        </div>
    }
} @else {
    <sb-loader></sb-loader>
}
